// extracted by mini-css-extract-plugin
export default {"grid":"NewPromotionVideosSelect_grid__+JUB7"};